<div class="page relatorio-gtm-login">
	<!-- <app-banner-internal title="Relatório GTM" subtitle="Área restrita"></app-banner-internal> -->

	<div class="container">
		<form class="login-card" [formGroup]="form" (ngSubmit)="onSubmit()">
			<h1>Login</h1>
			<p class="hint">Acesso restrito ao painel de medição do site.</p>

			<label for="gtm-login-user">Usuário</label>
			<input
				id="gtm-login-user"
				type="text"
				formControlName="user"
				autocomplete="username"
			/>

			<label for="gtm-login-password">Senha</label>
			<input
				id="gtm-login-password"
				type="password"
				formControlName="password"
				autocomplete="current-password"
			/>

			<p class="error" *ngIf="error">{{ error }}</p>

			<button type="submit" [disabled]="loading">{{ loading ? 'Entrando…' : 'Entrar' }}</button>
		</form>
	</div>
</div>
